import React from "react";

const defaultValue = {
    title: '',
    component: (<div></div>),
    open: false,
    style: {},
    modal2: {
        open: false,
        component: null,
        title: ''
    }
}

export const ModalActions = {
    OPEN_MODAL: 'OPEN_MODAL',
    FULLSCREEN: '',
    CLOSE_MODAL: 'CLOSE_MODAL',
}

const ModalContext = React.createContext(defaultValue)

function modalReducer(state, action)
{
    switch (action.type)
    {
        case ModalActions.FULLSCREEN: {
            return {
                ...state,
                fullscreen: action.fullscreen
            }
        }
        case ModalActions.OPEN_MODAL: {
            if(state.open)
            {
                return {
                    ...state,
                    modal2: {
                        open: true,
                        component: action.component,
                        title: action.title,
                        closable: action.closable
                    }
                }
            }

            return {
                ...state,
                open: true,
                component: action.component,
                title: action.title,
                style: action.style,
                closable: action.closable
            }
        }
        case ModalActions.CLOSE_MODAL: {
            if(state.modal2.open)
            {
                return {
                    ...state,
                    modal2: defaultValue.modal2
                }
            }
            return defaultValue
        }
        default: {
            return defaultValue
        }
    }
}

function ModalProvider({children})
{
    const [modal, dispatch] = React.useReducer(modalReducer, defaultValue);

    const value = {modal, dispatch};

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    )
}

function useModal()
{
    const context = React.useContext(ModalContext);

    if(!context)
        throw new Error('Modal Provider Error')

    const {modal, dispatch} = context;

    const setFullscreen = ({fullscreen}) => {
        dispatch({
            type: ModalActions.FULLSCREEN,
            fullscreen
        })
    }

    const openModal = ({title, component, style, closable}) => {
        dispatch({
            type: ModalActions.OPEN_MODAL,
            component: component,
            title: title,
            style: style,
            closable:closable
        })
    }

    const closeModal = () => {
        dispatch({
            type: ModalActions.CLOSE_MODAL,
        })
    }

    return {
        modal: modal,
        fullscreen: modal.fullscreen,
        setFullscreen,
        openModal,
        closeModal
    }
}

export {ModalProvider, useModal, ModalContext}
